import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getWorkflowTasks } from 'modules/accommodations/features/reservations/api';

export const useQueryWorkflowTasks = (calculationId: string) =>
  useQuery(
    [QUERY_KEYS.RENTALS_CALCULATION_WORKFLOW_TASKS, calculationId],
    () => getWorkflowTasks(calculationId),
    { enabled: !!calculationId },
  );
